<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="value => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none bg-white" to="/">
      <div class="img-logo">
        <img src="../../assets/fabbi_logo.jpeg" class="c-avatar-img" />
      </div>
    </CSidebarBrand>

    <ul
      class="c-sidebar-nav h-100 ps"
      style="position: relative; overflow-y: scroll !important"
    >
      <li class="c-sidebar-nav-item" data-v-3738b722="">
        <router-link
          :to="{ path: `/` }"
          class="c-sidebar-nav-link"
          target="_self"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-speedometer" />
          </svg>
          Dashboard
        </router-link>
      </li>
      <li class="c-sidebar-nav-title">Management</li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-speedometer" />
          </svg>
          {{ $t("sidebar.timesheet.title") }}
          <span
            class="badge badge-warning badge-pill"
            v-show="
              quantityRequest.countAllOverTimeRequest +
                quantityRequest.countAllTimeSheetRequest +
                quantityRequest.countAllRemoteTimeRequest >
                0
            "
          >
            {{
              quantityRequest.countAllOverTimeRequest +
                quantityRequest.countAllTimeSheetRequest +
                quantityRequest.countAllRemoteTimeRequest
            }}
          </span>
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/timesheets` }"
              class="c-sidebar-nav-link"
              :class="url === '/timesheets' ? 'c-active' : ''"
            >
              {{ $t("sidebar.timesheet.list") }}
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/overtime-requests` }"
              class="c-sidebar-nav-link"
              :class="
                url === '/overtime-requests' ||
                url === '/overtime-requests/approval'
                  ? 'c-active'
                  : ''
              "
            >
              {{ $t("sidebar.timesheet.ot") }}
              <span
                class="badge badge-info badge-pill ml-1"
                v-if="quantityRequest.countAllOverTimeRequest > 0"
              >
                {{ quantityRequest.countAllOverTimeRequest }}
              </span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/additional-timesheet` }"
              class="c-sidebar-nav-link"
              :class="url === '/additional-timesheet' ? 'c-active' : ''"
            >
              {{ $t("sidebar.timesheet.list_change") }}
              <span
                class="badge badge-info badge-pill ml-1"
                v-if="quantityRequest.countAllTimeSheetRequest > 0"
              >
                {{ quantityRequest.countAllTimeSheetRequest }}
              </span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/remote-request` }"
              class="c-sidebar-nav-link"
              :class="url === '/remote-request' ? 'c-active' : ''"
            >
              {{ $t("sidebar.timesheet.remote") }}
              <span
                class="badge badge-info badge-pill ml-1"
                v-if="quantityRequest.countAllRemoteTimeRequest > 0"
              >
                {{ quantityRequest.countAllRemoteTimeRequest }}
              </span>
            </router-link>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/logwork` }"
              class="c-sidebar-nav-link"
              :class="url === '/logwork' ? 'c-active' : ''"
            >
              {{ $t("sidebar.timesheet.logwork") }}
            </router-link>
          </li>
        </ul>
      </li>
      <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-description" />
          </svg>
          {{ $t("sidebar.sabbatical.title") }}
          <span
            class="badge badge-warning badge-pill"
            v-show="
              quantityRequest.requestSabbaticalLeave +
                quantityRequest.requestNoConfirmSabbaticalLeave >
                0
            "
          >
            {{
              quantityRequest.requestNoConfirmSabbaticalLeave +
                quantityRequest.requestSabbaticalLeave
            }}
          </span>
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <!--          <li class="c-sidebar-nav-item">-->
          <!--            <router-link-->
          <!--              :to="{ path: `/sabbatical-leave-request/create` }"-->
          <!--              class="c-sidebar-nav-link"-->
          <!--              :class="-->
          <!--                url === '/sabbatical-leave-request/create' ? 'c-active' : ''-->
          <!--              "-->
          <!--            >-->
          <!--              {{ $t("sidebar.sabbatical.create") }}-->
          <!--            </router-link>-->
          <!--          </li>-->
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ name: 'Sabbatical leave request' }"
              class="c-sidebar-nav-link"
              :class="url === '/sabbatical-leave-request' ? 'c-active' : ''"
            >
              {{ $t("sidebar.sabbatical.request_list") }}
              <span
                class="badge badge-info badge-pill"
                v-if="
                  quantityRequest.requestSabbaticalLeave +
                    quantityRequest.requestNoConfirmSabbaticalLeave >
                    0
                "
              >
                {{
                  quantityRequest.requestSabbaticalLeave +
                    quantityRequest.requestNoConfirmSabbaticalLeave
                }}
              </span>
            </router-link>
          </li>
          <!--          <li class="c-sidebar-nav-item">-->
          <!--            <router-link-->
          <!--              :to="{ path: `/sabbatical-leave-request` }"-->
          <!--              class="c-sidebar-nav-link"-->
          <!--              :class="url === '/sabbatical-leave-request' ? 'c-active' : ''"-->
          <!--            >-->
          <!--              {{ $t("sidebar.sabbatical.list") }}-->
          <!--              <span-->
          <!--                class="badge badge-info badge-pill"-->
          <!--                v-if="quantityRequest.requestNoConfirmSabbaticalLeave > 0"-->
          <!--              >-->
          <!--                {{ quantityRequest.requestNoConfirmSabbaticalLeave }}-->
          <!--              </span>-->
          <!--            </router-link>-->
          <!--          </li>-->
          <!--          <li class="c-sidebar-nav-item">-->
          <!--            <router-link-->
          <!--              :to="{ path: `/sabbatical-leave-request/approval` }"-->
          <!--              class="c-sidebar-nav-link"-->
          <!--              :class="-->
          <!--                url === '/sabbatical-leave-request/approval' ? 'c-active' : ''-->
          <!--              "-->
          <!--            >-->
          <!--              {{ $t("sidebar.sabbatical.approval") }}-->
          <!--              <span-->
          <!--                class="badge badge-info badge-pill"-->
          <!--                v-if="quantityRequest.requestSabbaticalLeave > 0"-->
          <!--              >-->
          <!--                {{ quantityRequest.requestSabbaticalLeave }}-->
          <!--              </span>-->
          <!--            </router-link>-->
          <!--          </li>-->
          <li class="c-sidebar-nav-item">
            <div class="c-sidebar-nav-wrapper">
              <router-link
                :to="{ path: `/sabbatical-leave-request/statistical` }"
                class="c-sidebar-nav-link"
                :class="
                  url === '/sabbatical-leave-request/statistical'
                    ? 'c-active'
                    : ''
                "
              >
                {{ $t("sidebar.sabbatical.statistical") }}
              </router-link>
            </div>
          </li>
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/sabbatical-leave-request/short-leave-request` }"
              class="c-sidebar-nav-link"
              :class="
                url === '/sabbatical-leave-request/short-leave-request'
                  ? 'c-active'
                  : ''
              "
            >
              {{ $t("sidebar.short_leave.list") }}
              <span
                class="badge badge-info badge-pill"
                v-if="quantityRequest.requestNoConfirmShortLeave > 0"
              >
                {{ quantityRequest.requestNoConfirmShortLeave }}
              </span>
            </router-link>
          </li>
        </ul>
      </li>
      <!--
        <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-layers" />
          </svg>
          {{ $t("sidebar.skill.title") }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/skill-sheet` }"
              class="c-sidebar-nav-link"
              :class="url === '/skill-sheet' ? 'c-active' : ''"
            >
              {{ $t("sidebar.skill.create") }}
            </router-link>
          </li>
        </ul>
      </li>

      <li>
        <router-link
          :to="{ path: `seating-chart` }"
          class="c-sidebar-nav-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-notes" />
          </svg>
          {{ $t("seat.seat-employee") }}
        </router-link>
      </li>
	  -->
      <template
        v-if="
          account.department_code == 'PR' ||
            account.job_title_code == 'DIRECTOR'
        "
      >
        <li>
          <router-link :to="{ path: `/news` }" class="c-sidebar-nav-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              role="img"
              class="c-sidebar-nav-icon"
            >
              <CIcon name="cil-notes" />
            </svg>
            News
          </router-link>
        </li>
      </template>

      <li>
        <router-link
          :to="{ path: `/note/document` }"
          class="c-sidebar-nav-link"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            role="img"
            class="c-sidebar-nav-icon"
          >
            <CIcon name="cil-notes" />
          </svg>
          {{ $t("note.tutorial") }}
        </router-link>
      </li>

      <li
        class="c-sidebar-nav-dropdown"
        @click="dropdown($event)"
        v-if="leftMenu"
      >
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="c-sidebar-nav-icon"
            style="opacity: 0.5"
          >
            <path
              d="M13.2857 6C14.536 6 15.7351 6.49669 16.6192 7.3808C17.5033 8.26491 18 9.46402 18 10.7143C18 11.9647 17.5033 13.1638 16.6192 14.0479C15.7351 14.932 14.536 15.4287 13.2857 15.4287C12.0353 15.4287 10.8362 14.932 9.95212 14.0479C9.06801 13.1638 8.57133 11.9647 8.57133 10.7143C8.57133 9.46402 9.06801 8.26491 9.95212 7.3808C10.8362 6.49669 12.0353 6 13.2857 6ZM15.5537 8.6966L12.0462 12.2049L11.0571 10.8858C10.9889 10.7948 10.8873 10.7347 10.7748 10.7186C10.6623 10.7026 10.548 10.7319 10.4571 10.8001C10.3661 10.8683 10.306 10.9698 10.2899 11.0823C10.2739 11.1948 10.3031 11.3091 10.3713 11.4001L11.6571 13.1144C11.694 13.1635 11.741 13.2042 11.7949 13.2336C11.8489 13.2629 11.9085 13.2804 11.9698 13.2847C12.0311 13.289 12.0926 13.2801 12.1502 13.2585C12.2077 13.237 12.26 13.2033 12.3034 13.1598L16.1606 9.30261C16.2386 9.22178 16.2818 9.11352 16.2808 9.00115C16.2799 8.88878 16.2348 8.78128 16.1553 8.70182C16.0759 8.62236 15.9684 8.57729 15.856 8.57631C15.7436 8.57533 15.6354 8.61853 15.5545 8.6966H15.5537Z"
              fill="#E5E7EB"
            />
            <path
              d="M7.73046 10.2861H0.642668L0.555239 10.2921C0.39388 10.3143 0.246964 10.397 0.144176 10.5233C0.0413889 10.6497 -0.00960577 10.8103 0.00149606 10.9728C0.0125979 11.1353 0.0849685 11.2875 0.203985 11.3987C0.323001 11.5099 0.479789 11.5718 0.642668 11.5719H7.77932C7.71384 11.1466 7.69745 10.7152 7.73046 10.2861Z"
              fill="#E5E7EB"
            />
            <path
              d="M8.34161 8.14315H0.642668C0.479789 8.1431 0.323001 8.08123 0.203985 7.97003C0.0849685 7.85883 0.0125979 7.7066 0.00149606 7.5441C-0.00960577 7.3816 0.0413889 7.22095 0.144176 7.0946C0.246964 6.96825 0.39388 6.88562 0.555239 6.86342L0.642668 6.85742H9.26562C8.89962 7.238 8.58847 7.67086 8.34161 8.14315Z"
              fill="#E5E7EB"
            />
            <path
              d="M16.5 3.42871H0.642668L0.555239 3.43471C0.39388 3.45691 0.246964 3.53954 0.144176 3.66589C0.0413889 3.79224 -0.00960577 3.95289 0.00149606 4.11539C0.0125979 4.27789 0.0849685 4.43012 0.203985 4.54132C0.323001 4.65251 0.479789 4.71439 0.642668 4.71444H16.5L16.5874 4.70844C16.7488 4.68624 16.8957 4.60361 16.9985 4.47726C17.1013 4.35091 17.1523 4.19026 17.1412 4.02776C17.1301 3.86526 17.0577 3.71303 16.9387 3.60183C16.8197 3.49064 16.6629 3.42876 16.5 3.42871Z"
              fill="#E5E7EB"
            />
            <path
              d="M16.5 0H0.642668L0.555239 0.00600004C0.39388 0.0282015 0.246964 0.110825 0.144176 0.237175C0.0413889 0.363525 -0.00960577 0.524181 0.00149606 0.686682C0.0125979 0.849182 0.0849685 1.00141 0.203985 1.11261C0.323001 1.2238 0.479789 1.28568 0.642668 1.28573H16.5L16.5874 1.27973C16.7488 1.25753 16.8957 1.1749 16.9985 1.04855C17.1013 0.922203 17.1523 0.761547 17.1412 0.599047C17.1301 0.436546 17.0577 0.284318 16.9387 0.173121C16.8197 0.0619244 16.6629 4.99228e-05 16.5 0Z"
              fill="#E5E7EB"
            />
          </svg>

          {{ $t("checkpoint.title") }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <template v-for="(item, index) of leftMenu.sub_menu_list">
            <li
              class="c-sidebar-nav-item"
              v-if="item.sub_menu === 'MEMBER_CHECKPOINT'"
              :key="index"
            >
              <router-link
                :to="{ path: `/checkpoint` }"
                class="c-sidebar-nav-link"
                :class="url === '/checkpoint' ? 'c-active' : ''"
              >
                {{ $t("checkpoint.options.self") }}
              </router-link>
            </li>
            <li
              class="c-sidebar-nav-item"
              v-if="item.sub_menu === 'pm_checkpoint'"
              :key="index"
            >
              <router-link
                :to="{ path: `/checkpoint/list-waiting-pm` }"
                class="c-sidebar-nav-link"
                :class="url === '/checkpoint/list-waiting-pm' ? 'c-active' : ''"
              >
                {{ $t("checkpoint.options.pm_checkpoint") }}
              </router-link>
            </li>
            <li
              class="c-sidebar-nav-item"
              v-if="item.sub_menu === 'dm_checkpoint'"
              :key="index"
            >
              <router-link
                :to="{ path: `/checkpoint/list-waiting-dm` }"
                class="c-sidebar-nav-link"
                :class="url === '/checkpoint/list-waiting-dm' ? 'c-active' : ''"
              >
                {{ $t("checkpoint.options.dm_checkpoint") }}
              </router-link>
            </li>
            <li
              class="c-sidebar-nav-item"
              v-if="item.sub_menu === 'interview_checkpoint'"
              :key="index"
            >
              <router-link
                :to="{ path: `/checkpoint/list-waiting-interview` }"
                class="c-sidebar-nav-link"
                :class="
                  url === '/checkpoint/list-waiting-interview' ? 'c-active' : ''
                "
              >
                {{ $t("checkpoint.options.interview_checkpoint") }}
              </router-link>
            </li>
          </template>
        </ul>
      </li>
      <li
        class="c-sidebar-nav-dropdown"
        v-if="existsProjectManagement"
        @click="dropdown($event)"
      >
        <a class="c-sidebar-nav-dropdown-toggle">
          <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="c-sidebar-nav-icon"
          >
            <path
              d="M16.9196 1.94527H10.7294C10.7209 1.94527 10.7133 1.94073 10.7097 1.93346L10.0713 0.638443C9.89113 0.271912 9.51073 0.0351562 9.10204 0.0351562H5.35982C4.76408 0.0351562 4.27945 0.519928 4.27945 1.1158V2.17502H3.21982C2.62422 2.17502 2.13959 2.65965 2.13959 3.25539V4.31461H1.08037C0.484634 4.31461 0 4.79924 0 5.39497V14.1373C0 14.7331 0.484634 15.2177 1.08037 15.2177H12.6403C13.2361 15.2177 13.7207 14.7331 13.7207 14.1373V13.078H14.78C15.3758 13.078 15.8604 12.5934 15.8604 11.9978V10.9385H16.9196C17.5154 10.9385 18 10.4539 18 9.85817V3.02591C18 2.43004 17.5154 1.94527 16.9196 1.94527ZM12.6403 14.1589H1.08037C1.06856 14.1589 1.05881 14.1493 1.05881 14.1373V5.39497C1.05881 5.38303 1.06856 5.37341 1.08037 5.37341H4.82286C4.82643 5.37341 4.82986 5.37465 4.83289 5.3763C4.8333 5.37657 4.83385 5.37643 4.83426 5.37671C4.83549 5.37753 4.83618 5.37904 4.83728 5.38C4.83907 5.38179 4.84113 5.3833 4.84222 5.3855L5.48094 6.68092C5.66428 7.05254 6.03561 7.28352 6.44994 7.28352H12.6403C12.6432 7.28352 12.6461 7.28407 12.6487 7.28517C12.6564 7.28847 12.6617 7.29616 12.6617 7.30508C12.6617 11.0388 12.6619 14.1033 12.6619 14.1373C12.6619 14.1493 12.6523 14.1589 12.6403 14.1589ZM14.8016 11.9978C14.8016 12.0096 14.792 12.0192 14.7802 12.0192H13.7207V7.30508C13.7207 6.70921 13.2359 6.22458 12.6402 6.22458H6.44994C6.44197 6.22458 6.43428 6.21977 6.43071 6.21249L5.79185 4.91707C5.60866 4.54587 5.23746 4.31461 4.823 4.31461H3.19839V3.25539C3.19839 3.24344 3.20801 3.23383 3.21982 3.23383H6.96245C6.97069 3.23383 6.9781 3.23836 6.98181 3.24605L7.62067 4.54147C7.80414 4.91309 8.17534 5.14394 8.58952 5.14394H14.7802C14.792 5.14394 14.8016 5.15355 14.8016 5.1655V11.9978ZM16.9412 9.85817C16.9412 9.87012 16.9316 9.87973 16.9196 9.87973H15.8604V5.1655C15.8604 4.56976 15.3759 4.08513 14.7802 4.08513H8.58952C8.58142 4.08513 8.57387 4.08032 8.57016 4.07291L7.93144 2.77789C7.74838 2.40601 7.37704 2.17502 6.96245 2.17502H5.33826V1.1158C5.33826 1.10371 5.34787 1.09396 5.35968 1.09396H9.1019C9.11 1.09396 9.11755 1.0985 9.12126 1.10605L9.76012 2.40189C9.94345 2.77322 10.3148 3.00407 10.7294 3.00407H16.9196C16.9314 3.00407 16.9411 3.01382 16.9411 3.02605V9.85817H16.9412Z"
              fill="rgba(255, 255, 255, 0.5)"
            />
            <path
              d="M9.40782 11.8574C9.11545 11.8574 8.87842 12.0945 8.87842 12.3868V12.6929C8.87842 12.9853 9.11545 13.2223 9.40782 13.2223C9.7002 13.2223 9.93723 12.9853 9.93723 12.6929V12.3868C9.93723 12.0945 9.7002 11.8574 9.40782 11.8574Z"
              fill="rgba(255, 255, 255, 0.5)"
            />
            <path
              d="M10.9505 11.8574C10.6582 11.8574 10.4211 12.0945 10.4211 12.3868V12.6929C10.4211 12.9853 10.6582 13.2223 10.9505 13.2223C11.2429 13.2223 11.4799 12.9853 11.4799 12.6929V12.3868C11.4799 12.0945 11.2429 11.8574 10.9505 11.8574Z"
              fill="rgba(255, 255, 255, 0.5)"
            />
          </svg>
          {{ $t("sidebar.project_management.title") }}
        </a>
        <ul class="c-sidebar-nav-dropdown-items">
          <li class="c-sidebar-nav-item">
            <router-link
              :to="{ path: `/project-management` }"
              class="c-sidebar-nav-link"
              :class="url.includes('/project-management') ? 'c-active' : ''"
            >
              {{ $t("sidebar.project_management.title") }}
            </router-link>
          </li>
        </ul>
      </li>
      <template v-if="account.department_code == 'PR' || account.id == '0038'">
        <li class="c-sidebar-nav-dropdown" @click="dropdown($event)">
          <a class="c-sidebar-nav-dropdown-toggle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style="opacity: 0.5"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-airplane-engines c-sidebar-nav-icon"
              viewBox="0 0 18 16"
            >
              <path
                d="M8 0c-.787 0-1.292.592-1.572 1.151A4.347 4.347 0 0 0 6 3v3.691l-2 1V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.191l-1.17.585A1.5 1.5 0 0 0 0 10.618V12a.5.5 0 0 0 .582.493l1.631-.272.313.937a.5.5 0 0 0 .948 0l.405-1.214 2.21-.369.375 2.253-1.318 1.318A.5.5 0 0 0 5.5 16h5a.5.5 0 0 0 .354-.854l-1.318-1.318.375-2.253 2.21.369.405 1.214a.5.5 0 0 0 .948 0l.313-.937 1.63.272A.5.5 0 0 0 16 12v-1.382a1.5 1.5 0 0 0-.83-1.342L14 8.691V7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.191l-2-1V3c0-.568-.14-1.271-.428-1.849C9.292.591 8.787 0 8 0ZM7 3c0-.432.11-.979.322-1.401C7.542 1.159 7.787 1 8 1c.213 0 .458.158.678.599C8.889 2.02 9 2.569 9 3v4a.5.5 0 0 0 .276.447l5.448 2.724a.5.5 0 0 1 .276.447v.792l-5.418-.903a.5.5 0 0 0-.575.41l-.5 3a.5.5 0 0 0 .14.437l.646.646H6.707l.647-.646a.5.5 0 0 0 .14-.436l-.5-3a.5.5 0 0 0-.576-.411L1 11.41v-.792a.5.5 0 0 1 .276-.447l5.448-2.724A.5.5 0 0 0 7 7V3Z"
              />
            </svg>
            Summer trip
          </a>
          <ul class="c-sidebar-nav-dropdown-items">
            <template>
              <li class="c-sidebar-nav-item">
                <router-link
                  :to="{ path: `/summer-trip/vote` }"
                  class="c-sidebar-nav-link"
                  :class="url === '/summer-trip/vote' ? 'c-active' : ''"
                >
                  {{ $t("summer_trip.label_vote") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ path: `/summer-trip/vote-chart` }"
                  class="c-sidebar-nav-link"
                  :class="url === '/summer-trip/vote-chart' ? 'c-active' : ''"
                >
                  {{ $t("summer_trip.label_vote_chart") }}
                </router-link>
              </li>
            </template>
          </ul>
        </li>
      </template>
      <div class="ps__rail-x">
        <div class="ps__thumb-x" tabindex="0"></div>
      </div>
      <div class="ps__rail-y">
        <div class="ps__thumb-y" tabindex="0"></div>
      </div>
    </ul>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="
        $store.dispatch('layout/setSidebar', ['sidebarMinimize', !minimize])
      "
    />
  </CSidebar>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Sidebar",
  data() {
    return {
      url: ""
    };
  },
  created() {
    let url = this.$route.path;
    let endLetter = url.substring(url.length - 1);
    if (endLetter == "/") {
      url = url.substring(0, url.length - 1);
    }
    this.url = url;
    this.$store.dispatch("checkpoint/getLeftMenu");
  },
  computed: {
    ...mapState("layout", {
      show: state => state.sidebarShow,
      minimize: state => state.sidebarMinimize
    }),
    ...mapGetters({
      quantityRequest: "commons/quantityRequest",
      leftMenu: "checkpoint/leftMenu",
      account: "auth/account",
      existsProjectManagement: "projectManagement/existsProjectManagement"
    })
  },
  methods: {
    dropdown(event) {
      if (
        typeof event.target.className != "object" &&
        event.target.className.includes("c-sidebar-nav-dropdown-toggle")
      ) {
        let navItem = document.querySelectorAll("li.c-show");
        event.currentTarget.classList.toggle("c-show");

        if (navItem.length > 0) {
          for (var i = 0; i < navItem.length; i++) {
            navItem[i].classList.remove("c-show");
          }
        }
      }
    }
  },
  watch: {
    $route(to) {
      let item = document.querySelector("a[href='" + to.path + "']");
      if (item) {
        item.classList.toggle("c-active");
        this.url = to.path;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.icon-warning {
  margin: 0 auto;
  color: yellow;
}

.img-logo {
  img {
    max-height: 50px;
    width: auto;
  }
}

.c-sidebar-minimized {
  .img-logo {
    display: none;
  }
}

.c-avatar-img {
  width: 100%;
  height: auto;
  border-radius: unset;
}

.ps__rail-x {
  left: 0px;
  bottom: 0px;
}

.ps__rail-y {
  top: 0px;
  right: 0px;
}

.ps__thumb-x {
  left: 0px;
  width: 0px;
}

.ps__thumb-y {
  top: 0px;
  height: 0px;
}
</style>
